import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useLang } from '../context/LangContext';

const CTA = () => {
  const { t, lang } = useLang();
  return (
    <section id="cta" className="py-24 md:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10">
        <div className="relative rounded-[36px] overflow-hidden bg-neutral-950 p-10 md:p-20">
          <div className="absolute inset-0">
            <div className="absolute -top-24 -left-24 w-[400px] h-[400px] bg-cyan-500/30 rounded-full blur-[100px]" />
            <div className="absolute -bottom-24 -right-24 w-[500px] h-[500px] bg-fuchsia-500/30 rounded-full blur-[120px]" />
          </div>
          <div className="relative text-center max-w-2xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-3 py-1.5 mb-6">
              <Sparkles className="w-3.5 h-3.5 text-cyan-400" />
              <span className="text-[12px] font-bold uppercase tracking-wider text-white">{lang === 'sv' ? 'Redo att skapa?' : 'جاهز للإبداع؟'}</span>
            </div>
            <h2 className="text-[40px] md:text-[64px] font-black tracking-[-0.025em] leading-[1] text-white">
              {lang === 'sv' ? 'Börja skapa idag. Helt gratis.' : 'ابدأ الإبداع اليوم. مجاناً تماماً.'}
            </h2>
            <p className="mt-6 text-[16px] text-neutral-300 max-w-xl mx-auto">
              {lang === 'sv' ? 'Ingen registrering, inga betalväggar, inga vattenstämplar. Bara ren kreativitet.' : 'بدون تسجيل، بدون حواجز دفع، بدون علامات مائية. إبداع خالص.'}
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Button className="h-14 px-8 rounded-full bg-white hover:bg-neutral-100 text-black font-bold text-[15px] group">
                {t.pricing.cta}
                <ArrowRight className="w-4 h-4 ml-2 rtl:ml-0 rtl:mr-2 rtl:rotate-180 group-hover:translate-x-1 rtl:group-hover:-translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
